import { useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { SuccessIcon } from 'foundations-assets/icons/components/SuccessIcon';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { CardWrapper } from 'foundations-components/transitional/components/Card';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import UsageTracker from '../../../utils/UsageTracker';
import useSearchParams from '../../../hooks/useSearchParams';
import { useRegisterForSession } from '../liveEventQueries';
import { getSessionEndTime, getSessionStartTime } from '../sessionTimeUtils';
import SessionDateDisplay from './SessionDateDisplay';
import { ZoomRegistrationFallbackModal } from '../ZoomRegistrationFallbackModal';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const SessionCard = ({
  contentName,
  isRegistered,
  liveEventId,
  onRegistered,
  session
}) => {
  const startTime = getSessionStartTime(session);
  const endTime = getSessionEndTime(session);
  const {
    isMobile
  } = useMediaQuery();
  const [{
    overviewSource
  }] = useSearchParams();
  const [fallbackUrl, setFallbackUrl] = useState();
  const {
    registerForSession,
    registrationLoading
  } = useRegisterForSession({
    eventId: liveEventId,
    onCompleted: onRegistered ? data => onRegistered(session, data) : undefined,
    onFallback: setFallbackUrl,
    onError: () => {
      FloatingAlertStore.addAlert({
        type: 'danger',
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academyComponents.liveEventOverviewModal.registrationError"
        })
      });
    }
  });
  const handleRegister = () => {
    UsageTracker.trackStandalone('Content Interaction', Object.assign({
      action: 'live-event-register-click',
      contentType: 'LIVE_EVENT',
      contentId: liveEventId,
      contentName,
      sessionId: session.id,
      startTime
    }, overviewSource && {
      source: overviewSource
    }));
    void registerForSession(session.eventSessionExternalId);
  };
  const handleFallbackCtaClick = () => {
    UsageTracker.trackStandalone('Content Interaction', Object.assign({
      action: 'live-event-register-fallback-click',
      contentType: 'LIVE_EVENT',
      contentId: liveEventId,
      contentName,
      sessionId: session.id,
      startTime
    }, overviewSource && {
      source: overviewSource
    }));
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [fallbackUrl && /*#__PURE__*/_jsx(ZoomRegistrationFallbackModal, {
      fallbackUrl: fallbackUrl,
      onClose: () => setFallbackUrl(undefined),
      onCtaClick: handleFallbackCtaClick
    }), /*#__PURE__*/_jsx(CardWrapper, {
      padding: "800",
      children: /*#__PURE__*/_jsxs(Flex, {
        alignItems: isMobile ? 'start' : 'center',
        flexDirection: isMobile ? 'column' : 'row',
        gap: "400",
        justifyContent: "space-between",
        children: [/*#__PURE__*/_jsx(Text, {
          typography: "heading-50",
          children: /*#__PURE__*/_jsx(SessionDateDisplay, {
            endTime: endTime,
            startTime: startTime
          })
        }), isRegistered ? /*#__PURE__*/_jsxs(Flex, {
          alignItems: "center",
          gap: "100",
          children: [/*#__PURE__*/_jsx(SuccessIcon, {
            color: "fill-positive-default"
          }), /*#__PURE__*/_jsx(Text, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "academyComponents.liveEventOverviewModal.registered"
            })
          })]
        }) : /*#__PURE__*/_jsx(LoadingButton, {
          loading: registrationLoading,
          onClick: handleRegister,
          use: "secondary",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "academyComponents.liveEventOverviewModal.registerForWorkshop"
          })
        })]
      })
    })]
  });
};
export { SessionCard };